<div class="add-container">
    <h1 class="solcitare-title">Adaugă registru</h1>
    <form class="add-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Nume</mat-label>
                    <input type="text" matInput formControlName="name" />
                    <mat-error *ngIf="!form.controls['name'].valid && form.controls['name'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Slug</mat-label>
                    <input type="text" matInput formControlName="slug" />
                    <mat-error *ngIf="!form.controls['slug'].valid && form.controls['slug'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Secvență Slug</mat-label>
                    <input type="text" matInput formControlName="slug_seq" />
                    <mat-error *ngIf="!form.controls['slug_seq'].valid && form.controls['slug_seq'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Primul Număr</mat-label>
                    <input type="number" matInput formControlName="first_number" />
                    <mat-error *ngIf="!form.controls['first_number'].valid && form.controls['first_number'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Tip Serie</mat-label>
                    <mat-select formControlName="serie_type">
                        <mat-option *ngFor="let row of serieType" [value]="row.id">
                            {{ row.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['serie_type'].valid && form.controls['serie_type'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Direcție</mat-label>
                    <mat-select formControlName="indoc_directie_id" (openedChange)="onDirectieSelectClosed()"
                        (selectionChange)="onDirectieChange($event.value)">
                        <mat-form-field class="px-2 w-100 sticky-input">
                            <input matInput [formControl]="directiiControl" (keydown)="$event.stopPropagation()"
                                (click)="$event.stopPropagation()" />
                        </mat-form-field>

                        <mat-option *ngIf="filteredDirectii.length === 0" disabled>
                            <span>No results found</span>
                        </mat-option>

                        <mat-option [value]="-1">-- Alegeți --</mat-option>
                        <mat-option *ngFor="let directie of filteredDirectii" [value]="directie.id">
                            {{ directie.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="!form.controls['indoc_directie_id'].valid && form.controls['indoc_directie_id'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Compartiment</mat-label>
                    <mat-select formControlName="indoc_compartiment_id" (openedChange)="onCompartimentSelectClosed()"
                        (selectionChange)="onCompartimentSelected($event.value)">
                        <mat-form-field class="px-2 w-100 sticky-input">
                            <input matInput [formControl]="compartimenteControl" (keydown)="$event.stopPropagation()"
                                (click)="$event.stopPropagation()" />
                        </mat-form-field>

                        <mat-option *ngIf="filteredCompartimente.length === 0" disabled>
                            <span>No results found</span>
                        </mat-option>

                        <mat-option [value]="-1">-- Alegeți --</mat-option>

                        <mat-option *ngFor="let compartiment of filteredCompartimente" [value]="compartiment.id">
                            {{ compartiment.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Registru Indoc</mat-label>
                    <mat-select formControlName="indoc_registru_id" (openedChange)="onRegistreSelectClosed()"
                        (selectionChange)="onRegistruSelected($event.value)">
                        <mat-form-field class="px-2 w-100 sticky-input">
                            <input matInput [formControl]="registreControl" (keydown)="$event.stopPropagation()"
                                (click)="$event.stopPropagation()" />
                        </mat-form-field>

                        <mat-option *ngIf="filteredRegistre.length === 0" disabled>
                            <span>No results found</span>
                        </mat-option>

                        <mat-option [value]="-1">-- Alegeți --</mat-option>
                        <mat-option *ngFor="let registru of filteredRegistre" [value]="registru.id">
                            {{ registru.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="!form.controls['indoc_registru_id'].valid && form.controls['indoc_registru_id'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Categorie Indoc</mat-label>
                    <mat-select formControlName="indoc_categorie_id"
                        (selectionChange)="onCategorieSelected($event.value)">
                        <mat-option [value]="-1">-- Alegeți --</mat-option>
                        <mat-option *ngFor="let categorie of categorii" [value]="categorie.id">
                            {{ categorie.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="!form.controls['indoc_categorie_id'].valid && form.controls['indoc_categorie_id'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Tip Document</mat-label>
                    <mat-select formControlName="indoc_document_type_id" (openedChange)="onDocumenteSelectClosed()"
                        (selectionChange)="onDocumentSelected($event.value)">
                        <mat-form-field class="px-2 w-100 sticky-input">
                            <input matInput [formControl]="documenteControl" (keydown)="$event.stopPropagation()"
                                (click)="$event.stopPropagation()" />
                        </mat-form-field>

                        <mat-option *ngIf="filteredDocumente.length === 0" disabled>
                            <span>No results found</span>
                        </mat-option>

                        <mat-option [value]="-1">-- Alegeți --</mat-option>
                        <mat-option *ngFor="let document of filteredDocumente" [value]="document.id">
                            {{ document.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="!form.controls['indoc_document_type_id'].valid && form.controls['indoc_document_type_id'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Sursă Indoc</mat-label>
                    <mat-select formControlName="indoc_source_id" (openedChange)="onSourcesSelectClosed()"
                        (selectionChange)="onSourceSelected($event.value)">
                        <mat-form-field class="px-2 w-100 sticky-input">
                            <input matInput [formControl]="sourcesControl" (keydown)="$event.stopPropagation()"
                                (click)="$event.stopPropagation()" />
                        </mat-form-field>

                        <mat-option *ngIf="filteredSources.length === 0" disabled>
                            <span>No results found</span>
                        </mat-option>

                        <mat-option [value]="-1">-- Alegeți --</mat-option>
                        <mat-option *ngFor="let source of filteredSources" [value]="source.id">
                            {{ source.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="!form.controls['indoc_source_id'].valid && form.controls['indoc_source_id'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Observații</mat-label>
                    <input type="text" matInput formControlName="observatii" />
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col d-flex justify-content-between">
                <button type="button" class="buttons" mat-flat-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" mat-flat-button color="primary" type="submit" [disabled]="form.invalid">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </div>
        </div>
    </form>

    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>